import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, User, ShoppingCart, LogIn } from 'lucide-react';

const Navbar = ({ cartCount = 0 }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check for logged in user
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <nav className="bg-black text-white sticky top-0 z-50 shadow-lg border-b border-gray-800">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
            <div className="w-12 h-12 rounded-full overflow-hidden flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_wax-crafts/artifacts/wge2dhc1_WhatsApp%20Image%202026-01-12%20at%2012.20.17.jpeg" 
                alt="Adina's Crafts Logo" 
                className="w-full h-full object-cover"
              />
            </div>
            <span className="text-2xl font-serif font-semibold">Adina's Crafts</span>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="hover:text-amber-200 transition-colors font-medium">Home</Link>
            <Link to="/shop" className="hover:text-amber-200 transition-colors font-medium">Shop</Link>
            <Link to="/reviews" className="hover:text-amber-200 transition-colors font-medium">Reviews</Link>
            <Link to="/about" className="hover:text-amber-200 transition-colors font-medium">About</Link>
            <Link to="/contact" className="hover:text-amber-200 transition-colors font-medium">Contact</Link>
          </div>

          {/* Icons */}
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setIsSearchOpen(!isSearchOpen)}
              className="hover:text-amber-200 transition-colors p-2"
            >
              <Search className="w-5 h-5" />
            </button>
            {user ? (
              <Link 
                to="/account" 
                className="hover:text-amber-200 transition-colors p-2 flex items-center gap-2"
                title={user.name}
              >
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="w-6 h-6 rounded-full" />
                ) : (
                  <User className="w-5 h-5" />
                )}
                <span className="hidden lg:inline text-sm">{user.name?.split(' ')[0]}</span>
              </Link>
            ) : (
              <Link to="/login" className="hover:text-amber-200 transition-colors p-2">
                <LogIn className="w-5 h-5" />
              </Link>
            )}
            <button 
              onClick={() => navigate('/cart')}
              className="hover:text-amber-200 transition-colors p-2 relative"
            >
              <ShoppingCart className="w-5 h-5" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-amber-400 text-[#8B4545] text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className="md:hidden mt-4 flex gap-4 text-sm">
          <Link to="/" className="hover:text-amber-200 transition-colors">Home</Link>
          <Link to="/shop" className="hover:text-amber-200 transition-colors">Shop</Link>
          <Link to="/reviews" className="hover:text-amber-200 transition-colors">Reviews</Link>
          <Link to="/about" className="hover:text-amber-200 transition-colors">About</Link>
          <Link to="/contact" className="hover:text-amber-200 transition-colors">Contact</Link>
        </div>

        {/* Search Bar */}
        {isSearchOpen && (
          <div className="mt-4">
            <input
              type="text"
              placeholder="Search products..."
              className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:border-amber-200"
            />
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;